import { useEffect } from 'react';
import { useQuickstartActions } from '@atlassian/jira-onboarding-quickstart-core/src/services/index.tsx';

export const useTrackMountedNudgesController = (nudgeId: string): void => {
	const [, { addMountedNudge, removeMountedNudge }] = useQuickstartActions();

	useEffect(() => {
		addMountedNudge(nudgeId);
		return () => {
			removeMountedNudge(nudgeId);
		};
	}, [addMountedNudge, nudgeId, removeMountedNudge]);
};
